import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center overflow-hidden" aria-labelledby="hero-heading">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Fresh%20organic%20vegetables%20harvested%20from%20a%20sunlit%20farm%20field%20with%20rows%20of%20green%20leafy%20vegetables%20and%20wooden%20crates%20filled%20with%20colorful%20produce%2C%20warm%20golden%20morning%20sunlight%2C%20soft%20natural%20atmosphere%2C%20clean%20agricultural%20aesthetic%2C%20artistic%20editorial%20photography%20with%20dreamy%20bokeh&width=1600&height=900&seq=hero-bg-01&orientation=landscape"
          alt="新鲜蔬菜产地直供 从田间到餐桌"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="max-w-2xl">
            <span className="inline-block px-3 py-1 bg-accent-500/90 text-background-50 text-xs md:text-sm font-medium rounded-full mb-5 animate-[fadeIn_600ms_ease-out]">
              新鲜蔬菜直供平台
            </span>
            <h2
              id="hero-heading"
              className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-5 animate-[slideUp_600ms_ease-out]"
            >
              从田间到餐桌
              <br />
              <span className="text-accent-300">新鲜</span>直达每一天
            </h2>
            <p className="text-sm md:text-base text-background-50/80 leading-relaxed mb-8 max-w-lg animate-[slideUp_600ms_ease-out_100ms]">
              新有菜严选全国优质蔬菜产地，每日清晨采摘，冷链直配到家。
              让每个家庭和餐饮企业都能享受到最新鲜的品质蔬菜。
            </p>
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 animate-[slideUp_600ms_ease-out_200ms]">
              <Link
                to="/categories"
                className="px-6 py-3 bg-primary-500 text-background-50 font-medium rounded-full text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                浏览蔬菜分类
              </Link>
              <Link
                to="/about"
                className="px-6 py-3 bg-background-50/15 backdrop-blur-sm text-background-50 font-medium rounded-full text-sm hover:bg-background-50/25 transition-all duration-200 whitespace-nowrap cursor-pointer border border-background-50/20"
              >
                了解更多
              </Link>
            </div>

            <div className="flex items-center gap-6 mt-10 animate-[slideUp_600ms_ease-out_300ms]">
              {[
                { value: '500+', label: '合作产地' },
                { value: '50万+', label: '服务家庭' },
                { value: '24h', label: '新鲜直达' },
              ].map((stat) => (
                <div key={stat.label} className="text-center">
                  <p className="text-xl md:text-2xl font-heading font-bold text-background-50">{stat.value}</p>
                  <p className="text-xs text-background-50/60 mt-1">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-s-line text-background-50/50 text-2xl"></i>
      </div>
    </section>
  );
}